import { ref } from '#imports'

export default (callback, time) => {
  const start = ref(0)
  const remaining = ref(time)
  const timeout = ref()

  const pause = () => {
    if (timeout.value) {
      clearTimeout(timeout.value)
      timeout.value = null
      remaining.value = remaining.value - (Date.now() - start.value)
    }
  }

  const resume = () => {
    if (!timeout.value && remaining.value > 0) {
      start.value = Date.now()

      timeout.value = setTimeout(() => {
        callback?.call()
        timeout.value = null
        remaining.value = null
      }, remaining.value)
    }
  }

  const reset = () => {
    clearTimeout(timeout.value)
    timeout.value = null
    start.value = 0
    remaining.value = time
  }

  const restart = () => {
    reset()
    resume()
  }

  return {
    pause,
    resume,
    reset,
    restart
  }
}
